import { flattenRoutes } from './flattenUrl'

export default [
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/layout-view'),
    children: [
      {
        path: '/home',
        name: 'HomeView',
        component: () => import('@/views/HomeView.vue'),
        meta: { title: '首页' },
      },
      {
        path: '/user-index',
        name: 'UserIndex',
        component: () => import('@/views/UserIndex.vue'),
        meta: { title: '用户信息', title_EN: 'User Index' },
      },
      ...flattenRoutes,
    ],
  },
  {
    path: '/login',
    name: 'LoginView',
    component: () => import('@/views/login2'),
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/AboutView.vue'),
  },
  {
    path: '/entry',
    name: 'RegisterPerson',
    component: () => import('@/views/registerPerson.vue'),
  },
]
